module.exports = __webpack_public_path__ + "static/media/20_plantilla_combo_cuadrada_marco_comida_28.9be8d61c.png";